import { render } from "./GraphBarPendidikan.vue?vue&type=template&id=9ea028b2"
import script from "./GraphBarPendidikan.vue?vue&type=script&lang=js"
export * from "./GraphBarPendidikan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__